package com.rosario.juridico.ui.screens

import kotlinx.browser.window

actual fun copiarAlPortapapeles(label: String, texto: String) {
    // Usamos la API del navegador para copiar al portapapeles
    window.navigator.clipboard.writeText(texto).then({
        // Opcional: Podrías mostrar un aviso si tuvieras un sistema de notificaciones global
    }, {
        // Manejo de error si el usuario deniega el permiso
        println("Error al copiar al portapapeles: $it")
    })
}
